export default __webpack_public_path__ + "5d717b7c50346193fd4c82468ceb54f4.png";